(function () {
  'use strict';

  let currentSubtotal = 0;

  function getPageCurrencyFormat() {
    let nameEngravingElement = document.querySelector('.c_variant-drawer-add-name-engraving[data-currency-format]');
    if (nameEngravingElement) {
      return nameEngravingElement.getAttribute('data-currency-format');
    }

    let formatElement = document.querySelector('[data-currency-format]');
    if (formatElement) {
      return formatElement.getAttribute('data-currency-format');
    }

    let w3MoneyFormat = document.querySelector('#w3-money-format');
    if (w3MoneyFormat && w3MoneyFormat.textContent && w3MoneyFormat.textContent.trim()) {
      return w3MoneyFormat.textContent.trim();
    }

    if (
      typeof window.themeVariables !== 'undefined' &&
      window.themeVariables.settings &&
      window.themeVariables.settings.moneyFormat
    ) {
      return window.themeVariables.settings.moneyFormat;
    }

    return '${{amount}}';
  }

  function getMoneyPrecision() {
    if (
      typeof window.themeVariables !== 'undefined' &&
      window.themeVariables.settings &&
      window.themeVariables.settings.cartCurrency
    ) {
      const code = window.themeVariables.settings.cartCurrency;
      if (code === 'JPY' || code === 'TWD') return 0;
    }
    return 2;
  }

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    } else {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      let formatString = format || '${{amount}}';
      let precision = getMoneyPrecision();

      function formatWithDelimiters(number, prec, thousands, decimal) {
        prec = prec !== undefined ? prec : precision;
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(prec);

        let parts = number.split('.');
        let dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        let centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      let match = formatString.match(placeholderRegex);

      if (match) {
        let value;
        switch (match[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, precision);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, precision, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          default:
            value = formatWithDelimiters(cents, precision);
        }

        return formatString.replace(placeholderRegex, value);
      }

      return cents.toString();
    }
  }

  function applyCurrencyFix(accessoryElement) {
    let currencyFormat = getPageCurrencyFormat();

    let priceElements, smallPriceElements;

    if (typeof $ !== 'undefined') {
      priceElements = $(accessoryElement).find('.accessory-price:not(.small)');
      smallPriceElements = $(accessoryElement).find('.accessory-price.small');
    } else {
      priceElements = accessoryElement.querySelectorAll('.accessory-price:not(.small)');
      smallPriceElements = accessoryElement.querySelectorAll('.accessory-price.small');
    }

    if (priceElements.length > 0) {
      Array.from(priceElements).forEach((priceEl) => {
        const originalPriceText = priceEl.textContent || priceEl.innerText;

        if (originalPriceText && originalPriceText.trim() !== '') {
          const originalPrice = Number(originalPriceText.replace(/[^0-9\.]+/g, '') * 100);

          if (!isNaN(originalPrice) && originalPrice > 0) {
            const formattedPrice = formatMoney(originalPrice, currencyFormat);
            priceEl.textContent = formattedPrice;
          }
        }
      });
    }

    if (smallPriceElements.length > 0) {
      Array.from(smallPriceElements).forEach((priceEl) => {
        const discountPriceText = priceEl.textContent || priceEl.innerText;

        if (discountPriceText && discountPriceText.trim() !== '') {
          const discountPrice = Number(discountPriceText.replace(/[^0-9\.]+/g, '') * 100);

          if (!isNaN(discountPrice) && discountPrice > 0) {
            const formattedDiscount = formatMoney(discountPrice, currencyFormat);
            priceEl.textContent = formattedDiscount;
          }
        }
      });
    }
  }

  function getSubtotalElement() {
    return document.querySelector('#subtotal-price');
  }

  function initializeSubtotal() {
    const subtotalElement = getSubtotalElement();
    if (subtotalElement) {
      currentSubtotal = parsePriceFromText(subtotalElement.textContent);
    }
  }

  function updateSubtotalDisplay(newSubtotal) {
    const subtotalElement = getSubtotalElement();
    if (subtotalElement) {
      subtotalElement.textContent = formatPrice(newSubtotal);
    }
  }

  function accessoryItemAddedCallback(div, product) {
    const accessoryElement = div[0] || div;
    const checkbox = accessoryElement.querySelector('input[type=checkbox]');

    if (!checkbox) return;

    applyCurrencyFix(accessoryElement);

    const priceElement = accessoryElement.querySelector('.accessory-price');
    let price = 0;
    if (priceElement) {
      price = parsePriceFromText(priceElement.textContent);
    }

    checkbox.addEventListener('change', function () {
      if (this.checked) {
        currentSubtotal += price;
      } else {
        currentSubtotal -= price;
      }
      updateSubtotalDisplay(currentSubtotal);
    });
  }

  function accessoryItemPriceChangedCallback(select, product, newPrice) {
    let accessoryElement;
    try {
      if (select && select.closest) {
        const jqElement = select.closest('.accessories-item');
        accessoryElement = jqElement.length > 0 ? jqElement[0] : null;
      }
    } catch (e) {
      return;
    }

    if (!accessoryElement) return;

    applyCurrencyFix(accessoryElement);

    const checkbox = accessoryElement.querySelector('input[type=checkbox]');
    if (!checkbox || !checkbox.checked) return;

    const priceElement = accessoryElement.querySelector('.accessory-price');
    if (!priceElement) return;

    const oldPrice = parsePriceFromText(priceElement.textContent);
    const numericNewPrice = typeof newPrice === 'number' ? newPrice : parsePriceFromText(newPrice.toString());

    const priceDifference = numericNewPrice - oldPrice;
    currentSubtotal += priceDifference;

    updateSubtotalDisplay(currentSubtotal);
  }

  function parsePriceFromText(priceText) {
    if (!priceText) return 0;
    const cleanText = priceText.replace(/[$,\s]/g, '');
    const match = cleanText.match(/([\d.]+)/);
    return match ? parseFloat(match[1]) : 0;
  }

  function formatPrice(price) {
    let format = getPageCurrencyFormat();
    let cents = Math.round(price * 100);
    return formatMoney(cents, format);
  }

  window.accessoryItemAddedCallback = accessoryItemAddedCallback;
  window.accessoryItemPriceChangedCallback = accessoryItemPriceChangedCallback;

  function addDataPriceEvents() {
    const dataPriceCheckboxes = document.querySelectorAll('[data-price] input[type=checkbox]');

    dataPriceCheckboxes.forEach((checkbox) => {
      if (checkbox.hasAttribute('data-subtotal-processed')) return;

      const container = checkbox.closest('[data-price]');
      if (!container) return;

      applyCurrencyFix(container);

      const price = parseFloat(container.getAttribute('data-price')) || 0;

      checkbox.addEventListener('change', function () {
        if (this.checked) {
          currentSubtotal += price;
        } else {
          currentSubtotal -= price;
        }
        updateSubtotalDisplay(currentSubtotal);
      });

      checkbox.setAttribute('data-subtotal-processed', 'true');
    });
  }

  // Name Engraving専用の処理を追加
  function addNameEngravingEvents() {
    const nameEngravingCheckboxes = document.querySelectorAll(
      '.c_variant-drawer-add-name-engraving input[type=checkbox]',
    );

    nameEngravingCheckboxes.forEach((checkbox) => {
      if (checkbox.hasAttribute('data-subtotal-processed')) return;

      // data-price属性から価格を取得（HTMLの形式: data-price=" 4,500"）
      const dataPriceAttr = checkbox.getAttribute('data-price');
      let price = 0;

      if (dataPriceAttr) {
        // 数字以外を除去して価格を抽出
        price = parseFloat(dataPriceAttr.replace(/[^0-9\.]/g, '')) || 0;
      }

      // または、span内のテキストから価格を抽出
      if (price === 0) {
        const container = checkbox.closest('.c_variant-drawer-add-name-engraving');
        if (container) {
          const spanText = container.querySelector('span') ? container.querySelector('span').textContent : '';
          const priceMatch = spanText.match(/[¥$€£]?[\d,]+/);
          if (priceMatch) {
            price = parseFloat(priceMatch[0].replace(/[^0-9\.]/g, '')) || 0;
          }
        }
      }

      checkbox.addEventListener('change', function () {
        if (this.checked) {
          currentSubtotal += price;
        } else {
          currentSubtotal -= price;
        }
        updateSubtotalDisplay(currentSubtotal);
      });

      checkbox.setAttribute('data-subtotal-processed', 'true');
    });
  }

  function initialize() {
    initializeSubtotal();
    addDataPriceEvents();
    addNameEngravingEvents(); // Name Engraving処理を追加
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('variant:changed', function (event) {
    window.location.reload();
  });
})();
